import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import styled from 'styled-components';

const StyledTabs = styled((props: TabsProps) => <Tabs {...props} />)`
    div[role='tab'] {
        user-select: none;
    }
`;

export default StyledTabs;
